<div class="page-wrap">
  <app-navbar></app-navbar>
  <div class="page-center">
    <div class="referral-card text-center">
  <i class="fa-solid fa-circle-check" style="color:#2B6CB0; font-size:48px; margin-bottom:20px"></i>
  <p style="font-size:18px; margin-bottom:30px; color:black">
    Thank you! You have successfully referred <span style="font-weight:600">{{ patientName || 'the patient' }}</span>
    to <span style="font-weight:600">{{ reasonText }}</span> in <span style="font-weight:600">{{ stateCode }}</span>.
    We will contact the patient to schedule an appointment. <span style="font-weight:600">Alternatively, if you know the patient's availability, you may schedule the appointment directly.</span>
  </p>
  <div class="actions center" style="justify-content:center">
    <button class="btn previous" style="width:100px; margin-right:20px" (click)="onExit()">Exit</button>
    <button class="btn primary next " style="width:200px"  (click)="onBook()">Book Appointment</button>
  </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>


